import { useMemo } from 'react';
import { getPaginationElements } from '@/utils/pagination';
import { NavigationButton } from './NavigationButton';
import { PaginationElementComponent } from './PaginationElementComponent';

interface PaginationNavigationProps {
  currentPage: number;
  totalPages: number;
  maxVisibleElements: number;
  handlePageChange: (page: number) => void;
}

export const PaginationNavigation = ({
  currentPage,
  totalPages,
  handlePageChange,
  maxVisibleElements,
}: PaginationNavigationProps) => {
  const paginationElements = useMemo(
    () =>
      getPaginationElements({
        currentPage,
        totalPages,
        maxVisibleElements,
      }),
    [currentPage, totalPages, maxVisibleElements]
  );

  return (
    <nav
      aria-label="Pagination"
      className="-space-x-px isolate inline-flex rounded-lg border border-gray-o25 shadow-sm"
    >
      <NavigationButton
        direction="left"
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      />
      {paginationElements.map((element, idx) => (
        <PaginationElementComponent
          currentPage={currentPage}
          element={element}
          handlePageChange={handlePageChange}
          key={`${element.type}-${idx}`}
        />
      ))}
      <NavigationButton
        direction="right"
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      />
    </nav>
  );
};
